<div class="content-wrapper">
  <div class="row">
    <div class="col-12 grid-margin stretch-card">
      <div class="card">
        <div class="row">
          <div class="col-12 col-xl-12 mb-4 mb-xl-0">
            <div class="card-body">
              <div style="display: flex">
                <div style="flex: 2">
                  <h2 class="card-title">{{ title }}</h2>
                  <p class="card-description">{{ subTitle }}</p>
                </div>

                <div class="newButtonAlignrigt" style="flex: 1">
                  <dx-button
                    class="themeButton"
                    text="Add New"
                    [routerLink]="[addNewUrl]"
                    *ngIf="isAddNewBtnEnabled === true"
                  ></dx-button>

                  <span class="cursor" [routerLink]="['../']" *ngIf="isAddNewBtnEnabled === false">
                    <img
                      style="width: 6%"
                      src="../../../../../assets/images/left-arrow-ash.png"
                      alt=""
                    />Back To List
                  </span>
                </div>
              </div>

              <ng-content></ng-content>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
